import { selectable, } from '../edgeless/mixin/index.js';
export function makeEmbedModel(SuperClass) {
    return selectable(SuperClass);
}
//# sourceMappingURL=embed-block-model.js.map